module.exports = __webpack_public_path__ + "img/1143.c4bc8846.gif";